import React from "react";
import { Redirect } from "react-router-dom";
// User profile
import UserProfile from "../pages/Authentication/UserProfile";
import AllSetting from "../pages/Authentication/Setting";
import AdminLogs from "../pages/Authentication/adminLogs";
import UserActivityLogs from "../pages/Authentication/UserActivityLogs";
// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import ForgetPwd from "../pages/Authentication/ForgetPassword";
import AccessDenied from "../pages/Authentication/AccessDenied";

// Dashboard
import VacancyList from "../pages/Vacancy/VacancyList.js";
import PendingList from "../pages/Pending_Application/PendingList.js";
import PreassessmentList from "../pages/Pending_Application/PreassessmentList";
import PrintPendingList from "../pages/Pending_Application/CandidateDetailsView.js";
import ScreeningList from "../pages/Screening_Test/ScreeningTest_CommonComp.js";
import ScheduledList from "../pages/Scheduled_Application/ScheduledList.js";
import SelectedList from "../pages/Selected_Application/SelectedList.js";
import OnboardedList from "../pages/Onboarded_Application/OnboardedList.js";
import OnholdList from "../pages/Onhold_Application/OnholdList.js";
import RejectedList from "../pages/Rejected_Application/RejectedList.js";
import CreateUser from "../pages/Users/createUser";
import EditUser from "../pages/Users/editUser";
import UserList from "../pages/Users/userList";
import CreateJob from "../pages/Jobs/createJob";
import LoginLinkedIn from "../pages/Jobs/LoginLinkedIn";
import Callback from "../pages/Jobs/Callback";
import EditJob from "../pages/Jobs/editJob";
import JobList from "../pages/Jobs/jobList";
import RoleList from "../pages/Roles/roleList";
import CreateRole from "../pages/Roles/createRole";
import EditRole from "../pages/Roles/editRole";
import Candidateconsolidate from "../pages/Candidate_consolidate/ViewDetails";
import Candidatereschedule from "../pages/Scheduled_Application/Candidatereschedule.js";
import EmployeeReferralList from "../pages/EmployeeReferral/EmployeeReferralList.js";
import EmployeeReferralCreate from "../pages/EmployeeReferral/EmployeeReferralCreate.js";
import EmployeeReferralEdit from "../pages/EmployeeReferral/EmployeeReferralEdit.js";
import MailTemplateEditor from "../pages/Company/MailTemplateEditor.js";
import TemplateList from "../pages/Company/TemplateList";
import DepartmentList from "../pages/Department/DepartmentList.js";
import CreateDepartment from "../pages/Department/CreateDepartment.js";
import EditDepartment from "../pages/Department/EditDepartment.js";
import CompetencyCategoryList from "../pages/CompetencyCategory/CompetencyCategoryList";
import CreateCompetencyCategory from "../pages/CompetencyCategory/CreateCompetencyCategory";
import EditCompetencyCategory from "../pages/CompetencyCategory/EditCompetencyCategory";
import QuestionTypeList from "../pages/Questions/QuestionTypeList";
import CreateQuestionType from "../pages/Questions/CreateQuestionType";
import EditQuestionType from "../pages/Questions/EditQuestionType";
import QuestionParentList from "../pages/Questions/QuestionParentList";
import CreateQuestionParent from "../pages/Questions/CreateQuestionParent";
import EditQuestionParent from "../pages/Questions/EditQuestionParent";
import QuestionBehaviourList from "../pages/Questions/QuestionBehaviourList";
import CreateQuestionBehaviour from "../pages/Questions/CreateQuestionBehaviour";
import EditQuestionBehaviour from "../pages/Questions/EditQuestionBehaviour";
import QuestionsList from "../pages/Questions/QuestionsList";
import CreateQuestions from "../pages/Questions/CreateQuestions";
import EditQuestions from "../pages/Questions/EditQuestions";
import ImportQuestionCsv from "../pages/Questions/ImportQuestionCsv";
import CreateVacancyType from "../pages/Vacancy_Type/createVacancyType";
import vacancyTypeList from "../pages/Vacancy_Type/vacancyTypeList";
import EditVacancyType from "../pages/Vacancy_Type/editVacancyType";
import CityList from "../pages/Location_Manager/Master_City/MasterCity";
import AreaList from "../pages/Location_Manager/Master_Area/MasterArea";
import StateList from "../pages/Location_Manager/Master_State/MasterState";
import RegionList from "../pages/Location_Manager/Master_Region/MasterRegion";
import CreateRegion from "../pages/Location_Manager/Master_Region/createRegion";
import EditRegion from "pages/Location_Manager/Master_Region/editRegion";
import CreateArea from "../pages/Location_Manager/Master_Area/createArea";
import CreateState from "../pages/Location_Manager/Master_State/createState";
import CreateCity from "../pages/Location_Manager/Master_City/createCity";
import CreateFranchise from "../pages/Franchise/createFranchise";
import FranchiseList from "../pages/Franchise/FranchiseList";
import CreateStore from "../pages/Location_Manager/Store/createStore";
import StoreList from "../pages/Location_Manager/Store/storeList";
import ViewDuplicateJob from "../pages/Dashboard/ViewDuplicateJobList";
import JobDetails from "../pages/Jobs/JobDetails";
import RecruitmentDashboard from "pages/Dashboard/Dashboard";
import PositionVsApplication from "pages/Reports/PositionVsApplication";
import FeedbackList from "pages/Feedback/FeedbackList";
import CandidateFeedbackList from "pages/Feedback/CandidateFeedbackList";
import PartialApplication from "../pages/Partial_Application/PartialApplication";
import CookiesList from "pages/Cookies/CookiesList";
import PIIList from "pages/Cookies/PIIList";
import AccountDeletionList from "pages/Cookies/DataDeletionRequestList";
import CookieConsentDashboard from "pages/Cookies/Dashboard";
import SentimentList from "pages/sentiment/sentimentList";
import JobPosting from "pages/Jobs/JobPostingAts";
import ArchiveList from "pages/ArchivedApplications/ArchiveList";
import ResourcePool from "pages/ResourcePool/ResourcePool";
import AllApplications from "pages/AllApplications/AllApplications";
import SkillList from "pages/SkillTag/SkillList";
import AddSkill from "pages/SkillTag/AddSkill";
import EditSkill from "pages/SkillTag/EditSkill";
import ImportResume from "pages/Jobs/ImportResume";
import CalenderTime from "pages/customCalender.js/CalenderTime";
import CreateJobNew from "pages/Jobs/CreateJobNew";
import Editjobnew from "pages/Jobs/editjobnew";
import ImportResumeUser from "pages/Candidate_consolidate/importResumeUser";
import EditState from "pages/Location_Manager/Master_State/editState";
import EditCity from "pages/Location_Manager/Master_City/editCity";
import EditStore from "pages/Location_Manager/Store/editStore";
import EditArea from "pages/Location_Manager/Master_Area/editArea";
import LoginSSO from "pages/Authentication/LoginSSO";
import NeuroBot from "pages/BotManage/ChatView";
import BotDashboard from "pages/BotManage/BotDashboard";
import AddIntent from "pages/BotManage/AddIntent";
import ViewIntent from "pages/BotManage/ViewIntent";
import NotFound from "components/NotFound";
import MCQDasboards from "pages/McqDashboard/MCQDasboards";
import Competencyquestion from "pages/McqDashboard/viewDetails";
import Organization from "pages/Organization/Organization";
import ViewOrganization from "pages/Organization/ViewOrganization";
import RoundTemplate from "pages/RoundTemplate/RoundTemplate";
import EmailsList from "../pages/Email/emailList";
import ResumeList from "pages/Resumes/ResumeList";
import AgencywiseApplication from "pages/Reports/AgencywiseApplication";
import WeeklyHiringsummary from "pages/Reports/WeeklyHiringsummary";

import CreateEnquiry from "../pages/enquiry/CreateEnquiry";
import EnquiryDetail from "../pages/enquiry/EnquiryDetail";
import EnquiryList from "../pages/enquiry/EnquiryList";
const authProtectedRoutes = [
  { path: "/", exact: true, component: () => <Redirect to="/dashboard" /> },
  { path: "/mail-template/:id", component: MailTemplateEditor },
  { path: "/template-list", component: TemplateList },
  { path: "/dashboard", component: RecruitmentDashboard },
  { path: "/cookie-consent-dashboard", component: CookieConsentDashboard },
  //user
  { path: "/create-user", component: CreateUser },
  { path: "/edit-user/:userId", component: EditUser },
  { path: "/user-list", component: UserList },
  //Role
  { path: "/create-role", component: CreateRole },
  { path: "/edit-role/:role_id", component: EditRole },
  { path: "/role-list", component: RoleList },
  //Job
  { path: "/create-job", component: CreateJob },
  { path: "/create-job-new", component: CreateJobNew },
  { path: "/edit-job-new/:jobId", component: Editjobnew },
  { path: "/edit-job/:jobId", component: EditJob },
  { path: "/job-list", component: JobList },
  { path: "/job-details/:vacancyId", component: JobDetails },
  { path: "/import-resume", component: ImportResume },
  { path: "/view-duplicate-job/:type/", component: ViewDuplicateJob },

  { path: "/login-linkedin", component: LoginLinkedIn },
  { path: "/callback", component: Callback },
  {
    path: "/candidate-reschedule/:interviewid",
    component: Candidatereschedule,
  },
  { path: "/email-list", component: EmailsList },
  //VacancyType
  { path: "/vacancyType-list", component: vacancyTypeList },
  { path: "/create-vacancyType", component: CreateVacancyType },
  { path: "/edit-vacancyType/:vacancyId", component: EditVacancyType },
  //profile
  { path: "/profile", component: UserProfile },
  { path: "/admin-logs", component: AdminLogs },
  { path: "/user-activity-logs", component: UserActivityLogs },
  { path: "/settings", component: AllSetting },
  // Users
  { path: "/vacancy-list", component: VacancyList },
  { path: "/pending-list", component: PendingList },
  { path: "/preassessment-list", component: PreassessmentList },
  { path: "/printpending-list/:appl_id", component: PrintPendingList },
  { path: "/screening-list", component: ScreeningList },
  { path: "/scheduled-list", component: ScheduledList },
  { path: "/selected-list", component: SelectedList },
  { path: "/onboarded-list", component: OnboardedList },
  { path: "/onhold-list", component: OnholdList },
  { path: "/rejected-list", component: RejectedList },
  { path: "/archive-list", component: ArchiveList },
  { path: "/position-application", component: PositionVsApplication },
  { path: "/partial-form", component: PartialApplication },
  { path: "/feedbacks", component: FeedbackList },
  { path: "/candidate-feedbacks", component: CandidateFeedbackList },
  { path: "/enquiries", component: EnquiryList },
  { path: "/enquiries/create", component: CreateEnquiry },
  { path: "/enquiries/:id", component: EnquiryDetail },
  { path: "/cookie-list", component: CookiesList },
  { path: "/consent-list", component: PIIList },
  { path: "/account-deletion-list", component: AccountDeletionList },
  { path: "/agency-application", component: AgencywiseApplication },
  { path: "/weekly-application", component: WeeklyHiringsummary },

  //Candidate_consolidate
  {
    path: "/candidate_consolidate/view-details/:appl_id",
    component: Candidateconsolidate,
  },
  {
    path: "/import-resume-user",
    component: ImportResumeUser,
  },
  //Employee Referrals
  { path: "/employee-referral-list", component: EmployeeReferralList },
  { path: "/create-employee-referral", component: EmployeeReferralCreate },
  { path: "/employee-referral-edit/:id", component: EmployeeReferralEdit },
  //Department Type
  { path: "/department-list", component: DepartmentList },
  { path: "/create-department", component: CreateDepartment },
  { path: "/edit-department/:id", component: EditDepartment },

  //mcq-dashboard
  { path: "/mcq-dashboard", component: MCQDasboards },
  {
    path: "/competency/view-details/:compt_id",
    component: Competencyquestion,
  },
  //CompetencyCategory
  { path: "/competency-category-list", component: CompetencyCategoryList },
  { path: "/create-competency-category", component: CreateCompetencyCategory },
  { path: "/edit-competency-category/:id", component: EditCompetencyCategory },
  //Oquestion Type Module
  { path: "/question-type-list", component: QuestionTypeList },
  { path: "/create-question-type", component: CreateQuestionType },
  { path: "/edit-question-type/:id", component: EditQuestionType },
  //Oquestion Parent Type
  { path: "/question-parent-list", component: QuestionParentList },
  { path: "/create-question-parent", component: CreateQuestionParent },
  { path: "/edit-question-parent/:id", component: EditQuestionParent },
  //Oquestion Behaviours Type
  { path: "/question-behaviour-list", component: QuestionBehaviourList },
  { path: "/create-question-behaviour", component: CreateQuestionBehaviour },
  { path: "/edit-question-behaviour/:id", component: EditQuestionBehaviour },
  //Oquestions Module
  { path: "/questions-list", component: QuestionsList },
  { path: "/create-question", component: CreateQuestions },
  { path: "/edit-question/:id", component: EditQuestions },
  { path: "/import-questions-csv", component: ImportQuestionCsv },
  //location Manager
  { path: "/city-list", component: CityList },
  { path: "/area-list", component: AreaList },
  { path: "/state-list", component: StateList },
  { path: "/region-list", component: RegionList },
  { path: "/create-region", component: CreateRegion },
  { path: "/edit-region/:regionId", component: EditRegion },
  { path: "/create-area", component: CreateArea },
  { path: "/edit-area/:areaId", component: EditArea },
  { path: "/create-state", component: CreateState },
  { path: "/edit-state/:stateId", component: EditState },
  { path: "/create-city", component: CreateCity },
  { path: "/edit-city/:cityId", component: EditCity },
  { path: "/create-franchise", component: CreateFranchise },
  { path: "/view-franchise", component: CreateFranchise },
  { path: "/edit-franchise", component: CreateFranchise },
  { path: "/franchise-list", component: FranchiseList },
  { path: "/resource-pool", component: ResourcePool },
  { path: "/all-applications", component: AllApplications },
  { path: "/create-store", component: CreateStore },
  { path: "/edit-store/:storeId", component: EditStore },
  { path: "/store-list", component: StoreList },
  { path: "/sentiment", component: SentimentList },
  { path: "/job-posting/:jobId", component: JobPosting },
  { path: "/skill-list", component: SkillList },
  { path: "/create-skill", component: AddSkill },
  { path: "/edit-skill/:skillId", component: EditSkill },

  { path: "/custome-calender", component: CalenderTime },
  { path: "/bot-manage", component: NeuroBot },
  { path: "/bot-dashboard", component: BotDashboard },
  { path: "/add-intent", component: AddIntent },
  { path: "/view-intent", component: ViewIntent },
  { path: "/organization", component: Organization },
  { path: "/organization/:id", component: ViewOrganization },
  { path: "/round/template", component: RoundTemplate },
  { path: "/resume-list", component: ResumeList },
  { path: "/*", component: NotFound },
];

const publicRoutes = [
  { path: "/logout", component: Logout },
  { path: "/sso/login/:token", component: LoginSSO },
  { path: "/login", component: Login },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/access-denied", component: AccessDenied },
];

export { authProtectedRoutes, publicRoutes };
